import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'h3-sama-logo',
  templateUrl: './sama-logo.svg',
  styleUrls: ['./sama-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SamaLogoComponent {
  @Input() fillColor?: string;
}
